import React, { useState } from "react";
import "./faqs.css";

function FAQ() {
  const faqs = [
    {
      question: "01. What services does Shri Adithya Hospitals offer?",
      answer:
        "We offer a full range of medical and surgical services, including emergency care, diagnostics, outpatient and inpatient services, and specialty care across departments like cardiology, orthopaedics, gynaecology, paediatrics, and more.",
    },
    {
      question: "02. How do I book an appointment?",
      answer:
        "You can book an appointment through our website, by calling our helpline, or by visiting the hospital.",
    },
    {
      question: "03. Do you offer 24/7 emergency services?",
      answer:
        "Yes, Shri Adithya Hospitals provides round-the-clock emergency care with experienced emergency physicians, nurses, and support staff ready to assist you at any time.",
    },
    {
      question: "04. Are walk-in patients accepted?",
      answer:
        "Yes, we accept walk-in patients. However, we recommend booking an appointment in advance to reduce wait times and ensure timely consultation.",
    },
    {
      question:
        "05. What insurance plans are accepted at Shri Adithya Hospitals?",
      answer:
        "We accept a wide range of health insurance plans. For details on specific providers, please visit our insurance desk or contact our billing department.",
    },
    {
      question: "06. What specialties are available at Shri Adithya Hospitals?",
      answer:
        "Our hospital houses specialists in cardiology, nephrology, neurology, general surgery, orthopedics, gynecology, ENT, dermatology, and more.",
    },
    {
      question: "7. Is cashless hospitalization available?",
      answer:
        "Yes, we offer cashless hospitalization in tie-up with several leading insurance companies and TPAs, subject to policy approval.",
    },
    {
      question: "8. Do you provide diagnostic and lab services?",
      answer:
        "Yes, we have an in-house diagnostics center with advanced imaging and laboratory services for faster and accurate results.",
    },
    {
      question: "9. Can I get a second opinion at your hospital?",
      answer:
        "Absolutely. Our specialists are available for second opinions, offering expert insights to help you make informed decisions about your treatment.",
    },
    {
      question: "10. How do I prepare for surgery or procedures?",
      answer:
        "Our care team will guide you with pre-operative instructions during your consultation. You’ll also receive written guidelines on food, medications, and arrival time.",
    },
    {
      question: "11. Do you provide post-treatment follow-up care?",
      answer:
        "Yes, we believe in continuity of care. Follow-up consultations, recovery support, and rehabilitation services are part of our patient-centered approach.",
    },
    {
      question:
        "12. Where is Shri Adihtya Hospitals located and how can I reach you?",
      answer:
        "We are located at Dammaiaguda which is near To Ecil. You can find detailed directions and contact information on our Contact Us page.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  function toggleFAQ(index) {
    setActiveIndex(activeIndex === index ? null : index);
  }

  return (
    <div className="faq-wrapper">
      <h2>FAQ</h2>
      <p>Frequently Asked Questions</p>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div className="faq-box" key={index}>
            <div
              onClick={() => toggleFAQ(index)}
              className={`faq-header ${activeIndex === index ? "open" : ""}`}
            >
              {faq.question}
            </div>
            <div className={`faq-body ${activeIndex === index ? "open" : ""}`}>
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
